
export interface Column {
  key: string;
  label: string;
  sortable?: boolean;
  width?: string;
}

export const ROW_HEIGHT = 41;

export const columns: Column[] = [
  { key: 'name',      label: 'Nombre',  sortable: true, width: '30%' },
  { key: 'email',     label: 'Correo',  sortable: true, width: '35%' },
  { key: 'domain',    label: 'Dominio', sortable: true, width: '20%' },
  { key: 'purchases', label: 'Compras', sortable: true, width: '15%' },
];

